
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[id]",
      function () {
        return require("private-next-pages/case-studies/[id].js");
      }
    ]);
  